// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8604":"c1ee895d","8688":"327ffc43"}[chunkId] + ".chunk.css";
};